export default function Footer() {
	return (
		<footer>
			<p>{`© Copyright ${new Date().getFullYear()} · Jai Tomar · All rights reserved`}</p>
			<a href="/license">license</a>
			<a href="/contact">contact</a>
		</footer>
	);
}
